<template>
  <div>
    <div class="home d-flex">
      <div class="intro-text d-flex align-items-end px-md-5">
        <div>
          <h1>{{ $t('Bory Promenáda') }}</h1>
          <p>{{ $t('Vďaka svojej tesnej blízkosti k Bory Mall je tretia') }}</p>
          <b-button to="/nasa-stvrt" class="d-block d-md-inline-block" squared variant="primary">{{ $t('O bývaní na Boroch') }}</b-button>
<!--          <b-button class="d-block d-md-inline-block ml-md-3 mt-2 mt-md-0" squared variant="light">Stiahnuť brožúru</b-button>-->
        </div>
      </div>
    </div>

    <ScheduleTimeline :phases="schedulePhases" />

    <section class="section-3 p-3">
      <div class="">
        <div class="row px-3 mb-3">
          <div class="col-md-7 bg-img"></div>
          <div class="col-md-5 p-0 px-md-5 py-3">
            <h2 v-html="$t('Buďte pri tom,<br> čo je dostupné')"></h2>
            <p v-html="$t('Rovnako ako v 1. a 2. etape aj túto vystihujú veľkorysé zelené')"></p>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-1">
              <h3 v-html="$t('8 500 m<sup>2</sup><br> zelene')"></h3>
              <p>{{ $t('Centrálna časť je bezpečná pre obyvateľov') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-2">
              <h3 v-html="$t('488<br> parkovacích miest')"></h3>
              <p>{{ $t('Dostupných bude celkovo 320') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-3">
              <h3 v-html="$t('3<br> detské ihriská')"></h3>
              <p>{{ $t('Pre najmladších obyvateľov staviame') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-bottom p-md-3 pl-md-5">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 py-4">
          <h2 class="mb-4">{{ $t('Domov, ktorý zažiari') }}</h2>
          <p class="mb-3" v-html="$t('Vďaka širokej ponuke štandardu si každý obyvateľ vyberie')"></p>
<!--          <b-button squared variant="primary">Stiahnuť katalóg štandardov</b-button>-->
        </div>
        <div class="col-md-6 pb-3 pb-md-0 pr-md-0">
          <div class="right-img"></div>
        </div>
      </div>
    </section>

    <section class="about-bottom-2">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 bg"></div>
        <div class="col-md-6 signature-section">
          <p class="mb-4 text-italic font-weight-bolder">{{ $t('„Tretia etapa projektu ponúka štýlové a moderné') }}</p>
          <p class="name">Sadovsky&Architects</p>
          <p class="name">Mateja Vonkomerová a Silvia Rosíková, Oliver Sadovský</p>
        </div>
      </div>
    </section>

    <ContactForm selectedStage="bory3"></ContactForm>
  </div>
</template>

<script>
import ScrollTo from "@/utils/scrollTo.util";
import ContactForm from "@/components/shared/ContactForm";
import ScheduleTimeline from "@/components/home/ScheduleTimeline";

export default {
  name: "Bory3",
  components: {ContactForm, ScheduleTimeline},
  data() {
    return {
      schedulePhases: [
        { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '3. kvartál 2020', status: 'fill' },
        { icon: 'hruba-stavba', title: 'Žiadosť<br> o kolaudáciu', date: '3. kvartál 2022', status: 'fill' },
        { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '3. - 4. kvartál 2022', status: 'fill' },
        { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1. - 3. kvartál 2023', status: 'fill' },
        { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie', status: 'fill' }
      ]
    }
  },
  mounted () {
    ScrollTo.hash(this,  () => window.scrollTo(0, 0))
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
.about-bottom-2
  .bg
    background: url(../assets/images/bory3/bottom-image.jpg) center/cover no-repeat
.about-bottom
  .right-img
    background: url(../assets/images/cam_bedroom_01.jpg) center/cover no-repeat

.section-3
  background: var(--grey)
  color: #fff
  text-align: left

  &.free-offer
    .bg-img
      background: url(../assets/images/bory3/bory3-domov.jpg) center/cover no-repeat

    h2
      font-weight: 500
    p
      font-size: 20px
  .bg-img
    background: url("../assets/images/Bory_Promenada-3.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 320px
    font-weight: 500
    &:last-child
      margin-bottom: 220px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory3/bory3.jpg") center/cover no-repeat
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/Bory_Promenada-1.jpg") bottom/cover no-repeat
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory3/bory3-ihriska.jpg") center/cover no-repeat
    background-position: -350px center
    @media (max-width: $md)
      background-position: center
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/Bory_BH3-31.jpg") top/cover no-repeat
  p
    margin-bottom: 30px
    max-width: 770px

  .badge-offer
    position: absolute
    top: 25%
    right: 20%
    width: 236px

    @media (max-width: $md)
      top: 20%
      left: 50%
      transform: translateX(-50%)
      max-width: 160px

    img
      max-width: 100%

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px
</style>
